// src/components/profiles/Member/MemberProfileLimitedOwner.tsx

"use client";

import React from "react";
import { LifeBuoy, ShieldAlert } from "lucide-react";

import { AvatarDisplay } from "../../common";
import type { MemberProfileType } from "../../../types/profiles/memberProfileTypes";

import {
  getOwnerProfileGateMessage,
  getOwnerProfileGateTitle,
  getSafeProfileGateReason,
} from "../../../utils/profiles/profileGate";

import "./MemberProfileLimitedOwner.css";

type MemberProfileLimitedOwnerProps = {
  member: MemberProfileType;
};

const MemberProfileLimitedOwner: React.FC<MemberProfileLimitedOwnerProps> = ({
  member,
}) => {
  const user = member.user;

  const reason = getSafeProfileGateReason(member, {
    ignoreAccountState: true,
  });

  const title = getOwnerProfileGateTitle(reason);
  const message = getOwnerProfileGateMessage(member, reason);

  const username = user?.username || "";
  const fullName =
    `${user?.name ?? ""} ${user?.family ?? ""}`.trim() || username;

  const avatar = user?.avatar_cdn_url || null;
  const placeholderSrc = user?.avatar_url || user?.profile_image || null;

  return (
    <main className="mp-limited-owner">
      <section className="mp-limited-owner__card" aria-live="polite">
        <div className="mp-limited-owner__avatar-wrap">
          <AvatarDisplay
            userId={user?.id}
            src={avatar}
            placeholderSrc={placeholderSrc}
            alt={fullName || username}
            size="xl"
            shape="rounded"
            type="user"
            isVerifiedIdentity={Boolean(user?.is_verified_identity)}
            isTownlitVerified={Boolean(user?.is_townlit_verified)}
            withBorder
            borderColor={user?.label?.color || "var(--color-primary)"}
          />
        </div>

        <div className="mp-limited-owner__identity">
          <h1 className="mp-limited-owner__username">
            @{username}
          </h1>

          {fullName && fullName !== username && (
            <p className="mp-limited-owner__name">
              {fullName}
            </p>
          )}
        </div>

        <div className="mp-limited-owner__notice">
          <div className="mp-limited-owner__notice-icon">
            <ShieldAlert size={24} aria-hidden="true" />
          </div>

          <div className="mp-limited-owner__notice-copy">
            <h2>{title}</h2>
            <p>{message}</p>
          </div>
        </div>

      </section>
    </main>
  );
};

export default MemberProfileLimitedOwner;